import { render, staticRenderFns } from "./SemInformacoes.vue?vue&type=template&id=7269a353&scoped=true&"
import script from "./SemInformacoes.vue?vue&type=script&lang=js&"
export * from "./SemInformacoes.vue?vue&type=script&lang=js&"
import style0 from "./SemInformacoes.vue?vue&type=style&index=0&id=7269a353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7269a353",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
